import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../../hooks/useStore';
import { useQuery } from '@tanstack/react-query';
import { Box, Typography } from '@mui/material';
import { SyncLogs } from '.';
import { Loading, RoundedPaper } from '../../../../../lib/components';
import { StyledHead } from '../../../../../lib/components/compound/pages/head/styled';
import { usePxtraApiClient } from '../../../../../hooks/usePxtraApiClient';
import { useTranslation } from 'react-i18next';
import { useCompanySettings } from '../../../../../queries/company';
import { Button } from '../../../../../lib/components/atomic/button';
import { useState } from 'react';
import { TriggerSyncDialog } from './TriggerSyncDialog';

export const ExportLogsView = observer(() => {
  const { companyStore } = useStore();
  const apiClient = usePxtraApiClient();
  const { t } = useTranslation();
  const company = companyStore.company?.id ?? 'MISSING_ID';
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const { data: companySettings } = useCompanySettings(companyStore.company?.id ?? '');
  const { isRefetching, isFetching } = useQuery({
    queryKey: ['company', company, 'settings', 'payroll'],
    queryFn: () =>
      apiClient.companies.companiesSettingsPayrollRetrieve({
        id: company
      })
  });

  const isPersonio = companySettings?.payroll_system === 'PERSONIO';

  return (
    <RoundedPaper>
      {isFetching || isRefetching ? (
        <Loading />
      ) : (
        <>
          <StyledHead>
            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
              <Typography variant="h3">{t('export:LOGS')}</Typography>
              {isPersonio && (
                <Button onClick={() => setIsDialogOpen(true)}>{t('export:START_SYNC')}</Button>
              )}
            </Box>
          </StyledHead>
          <Box paddingX={2} paddingBottom={3}>
            <SyncLogs type={isPersonio ? 'personio' : 'paychex'} />
          </Box>
          <TriggerSyncDialog
            open={isDialogOpen}
            companyId={company}
            onClose={() => setIsDialogOpen(false)}
          />
        </>
      )}
    </RoundedPaper>
  );
});
